import { render, staticRenderFns } from "./g-table-dialog.vue?vue&type=template&id=0adb6fdd&scoped=true&"
import script from "./g-table-dialog.vue?vue&type=script&lang=js&"
export * from "./g-table-dialog.vue?vue&type=script&lang=js&"
import style0 from "./g-table-dialog.vue?vue&type=style&index=0&id=0adb6fdd&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0adb6fdd",
  null
  
)

export default component.exports